import { SEARCH_PARAMS } from "common/constants"
import { nanoid } from "nanoid"
import * as ROUTES from "routes/RoutePaths"

export const directAccessCreationPaths = (t: $TSMigrationFixMe) => [
  {
    title: `${t("nav.directAccess.createLabel")}`,
    key: nanoid(),
    subMenu: [
      {
        key: nanoid(),
        text: `${t("nav.directAccess.remittanceCollectionLabel")}`,
        path: `${ROUTES.REMESAS}?${SEARCH_PARAMS.GOTO}=${SEARCH_PARAMS.REMESAS_COBRO}`,
        nameIcon: "img-remesa-cobro.svg",
      },
      {
        key: nanoid(),
        text: `${t("nav.directAccess.remittancePaymentLabel")}`,
        path: `${ROUTES.REMESAS}?${SEARCH_PARAMS.GOTO}=${SEARCH_PARAMS.REMESAS_PAGO}`,
        nameIcon: "img-remesa-pago.svg",
      },
      {
        key: nanoid(),
        text: `${t("nav.directAccess.accountingEntryLabel")}`,
        path: `${ROUTES.CONTABILIDAD_CUENTAS_CONTABLES}?${SEARCH_PARAMS.GOTO}=${SEARCH_PARAMS.ASIENTO_CONTABLE}`,
        nameIcon: "img-asiento-contable.svg",
      },
      {
        key: nanoid(),
        text: `${t("nav.directAccess.accountingAccountLabel")}`,
        path: `${ROUTES.CONTABILIDAD_CUENTAS_CONTABLES}?${SEARCH_PARAMS.GOTO}=${SEARCH_PARAMS.CUENTA_CONTABLE}`,
        nameIcon: "img-cuenta-contable.svg",
      },
      {
        key: nanoid(),
        text: `${t("nav.directAccess.paymentLabel")}`,
        path: `${ROUTES.PAGOS_COBROS}?${SEARCH_PARAMS.GOTO}=${SEARCH_PARAMS.PAGO}`,
        nameIcon: "img-pago.svg",
      },
      {
        key: nanoid(),
        text: `${t("nav.directAccess.collectLabel")}`,
        path: `${ROUTES.PAGOS_COBROS}?${SEARCH_PARAMS.GOTO}=${SEARCH_PARAMS.COBRO}`,
        nameIcon: "img-cobro.svg",
      },
      {
        key: nanoid(),
        text: `${t("nav.directAccess.contactLabel")}`,
        path: `${ROUTES.CONTACTOS}?${SEARCH_PARAMS.GOTO}=${SEARCH_PARAMS.CONTACTO}`,
        nameIcon: "img-cliente.svg",
      },
      {
        key: nanoid(),
        text: `${t("nav.directAccess.articleLabel")}`,
        path: `${ROUTES.ARTICULOS}?${SEARCH_PARAMS.GOTO}=${SEARCH_PARAMS.ARTICULO}`,
        nameIcon: "img-articulo.svg",
      },
      {
        key: nanoid(),
        text: `${t("nav.directAccess.catalogLabel")}`,
        path: ROUTES.CREAR_CATALOGO,
        nameIcon: "img-catalogo.svg",
      },
      {
        key: nanoid(),
        text: `${t("nav.directAccess.bankAccountLabel")}`,
        path: `${ROUTES.EMPRESA}?${SEARCH_PARAMS.GOTO}=${SEARCH_PARAMS.CUENTA_BANCARIA}`,
        nameIcon: "img-cuenta-bancaria.svg",
      },
      {
        key: nanoid(),
        text: `${t("nav.directAccess.userLabel")}`,
        path: `${ROUTES.ADMROLES}?${SEARCH_PARAMS.GOTO}=${SEARCH_PARAMS.USUARIO}`,
        nameIcon: "img-usuario.svg",
      },
      {
        key: nanoid(),
        text: `${t("nav.directAccess.departamentLabel")}`,
        path: `${ROUTES.ADMROLES}?${SEARCH_PARAMS.GOTO}=${SEARCH_PARAMS.DEPARTAMENTO}`,
        nameIcon: "img-departamento.svg",
      },
      {
        key: nanoid(),
        text: `${t("nav.directAccess.loanLabel")}`,
        path: `${ROUTES.PRESTAMOS}?${SEARCH_PARAMS.GOTO}=${SEARCH_PARAMS.PRESTAMO}`,
        nameIcon: "img-prestamo.svg",
      },
    ],
  },
]

export const CREATE_DOCUMENT_SECTION = (t: $TSMigrationFixMe) => [
  {
    key: nanoid(),
    text: `${t("nav.directAccess.quotationLabel")}`,
    path: `${ROUTES.CREAR_PRESUPUESTO}`,
    nameIcon: "img-presupuesto.svg",
  },
  {
    key: nanoid(),
    text: `${t("nav.directAccess.orderLabel")}`,
    path: `${ROUTES.CREAR_PEDIDO}`,
    nameIcon: "img-pedido.svg",
  },
  {
    key: nanoid(),
    text: `${t("nav.directAccess.deliveryLabel")}`,
    path: `${ROUTES.CREAR_ALBARAN}`,
    nameIcon: "img-albaran.svg",
  },
  {
    key: nanoid(),
    text: `${t("nav.directAccess.invoceLabel")}`,
    path: `${ROUTES.CREAR_FACTURA}`,
    nameIcon: "img-factura.svg",
  },
  {
    key: nanoid(),
    text: `${t("nav.directAccess.invoceRecLabel")}`,
    path: `${ROUTES.CREAR_FACTURA_RECURRENTE}`,
    nameIcon: "img-factura-recurrente.svg",
  },
]

export const getOptionFacturasModal = (
  goTo: $TSMigrationFixMe,
  settings: $TSMigrationFixMe
) => {
  return [
    {
      label: "OCR",
      text: "",
      icon: settings.pdf,
      callback: () => goTo(ROUTES.IMPORTAR_FACTURAS_OCR),
      id: 1,
    },
    {
      label: "FacturaE",
      text: "",
      icon: settings.xml,
      callback: () => goTo(ROUTES.IMPORTAR_FACTURAE),
      id: 2,
    },
    {
      label: "Excel",
      text: "",
      icon: settings.xlxs,
      callback: () => goTo(ROUTES.IMPORTAR_FACTURAS),
      id: 4,
    },
  ]
}
